<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <div>
                <h5>List of Customers</h5>
                <small
                  >Select a customer to view further details and generate an
                  invoice.</small
                >
                <div
                  id="first-row"
                  style="display: grid; grid-template-columns: 3fr 2fr 2fr 2fr;"
                  class="mb-3 border rounded mt-2"
                >
                  <div class="d-flex align-items-center p-2">
                    <label for="" style="white-space: nowrap;" class="mr-1"
                      >Client Name:</label
                    >
                    <select
                      class="form-control"
                      name=""
                      id=""
                      v-model="client_id"
                    >
                      <option value="">1</option>
                      <option value="">1</option>
                      <option value="">1</option>
                    </select>
                  </div>
                  <div class="d-flex align-items-center p-2">
                    <label for="" style="white-space: nowrap;" class="mr-1"
                      >Start Date :</label
                    >
                    <a-date-picker
                      format="MM/DD/YYYY"
                      id="startDate"
                      v-model="start_date"
                    />
                  </div>
                  <div class="d-flex align-items-center p-2">
                    <label for="" style="white-space: nowrap;" class="mr-1"
                      >End Date :</label
                    >
                    <a-date-picker
                      format="MM/DD/YYYY"
                      id="endDate"
                      v-model="end_date"
                    />
                  </div>
                  <div class="d-flex align-items-center p-2">
                    <label for="" style="white-space: nowrap;" class="mr-1"
                      >Page Size:</label
                    >
                    <a-date-picker
                      format="MM/DD/YYYY"
                      id="endDate"
                      v-model="end_date"
                    />
                  </div>
                </div>
                <div id="client_list" class="border rounded p-2">
                  <ClientCard
                    clientName="Calamp"
                    clientEmail="calamp@test.com"
                    consumedPointsPercentage="25"
                    consumedPoints="234,300"
                  />
                  <ClientCard
                    clientName="Calamp"
                    clientEmail="calamp@test.com"
                    consumedPointsPercentage="50"
                    consumedPoints="234,300"
                  />
                  <ClientCard
                    clientName="Calamp"
                    clientEmail="calamp@test.com"
                    consumedPointsPercentage="80"
                    consumedPoints="234,300"
                  />
                </div>
              </div>
              <div v-if="Loading === true">
                <div class="centered-spinner">
                  <a-spin />
                </div>
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import ClientCard from "./ClientCard.vue";

export default {
  name: "Prefunding",
  data() {
    return {
      Loading: false,
      pg_num: 1,
      pg_size: 5,
      client_id: null,
      start_date: null,
      end_date: null,
    };
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
    ClientCard,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "prefunding",
        activeMenu: this.activeMenu
          ? this.activeMenu
          : "prefundingAndInvoicing",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.scrollToTop();
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.disable {
  opacity: 0.5;
  pointer-events: none;
}
</style>
